// @flow

import styled from '@emotion/styled'
import { GatsbyImage, StaticImage } from 'gatsby-plugin-image'
import * as React from 'react'

import { colors, media } from '@toggl/style'

import * as text from '../text'

type Props = {|
  icon:
    | React.Element<'img'>
    | React.Element<typeof GatsbyImage>
    | React.Element<typeof StaticImage>,
  title: string,
  paragraph: string | React.Node,
  image:
    | React.Element<'img'>
    | React.Element<typeof GatsbyImage>
    | React.Element<typeof StaticImage>,
|}

export function FeatureLeftRight({ image, title, paragraph, icon }: Props) {
  return (
    <Root>
      <FeaturesImage>{image}</FeaturesImage>
      <FeaturesText>
        {icon}
        <Title color={colors.darkPurple}>{title}</Title>
        <text.P3 color={colors.darkPurple}>{paragraph}</text.P3>
      </FeaturesText>
    </Root>
  )
}

const Root: React.ComponentType<any> = styled.div`
  margin: 30px auto;
  ${media.mq[1]} {
    display: flex;
    align-items: center;
    &:nth-of-type(odd) {
      flex-direction: row-reverse;
    }
    &:nth-of-type(even) > div:nth-of-type(2) {
      padding-left: 50px;
      padding-right: 0;
    }
  }
  ${media.mq[2]} {
    &:nth-of-type(odd) > div:nth-of-type(2) {
      padding-right: 150px;
    }
    &:nth-of-type(even) > div:nth-of-type(2) {
      padding-left: 130px;
      padding-right: 25px;
    }
  }
`

const FeaturesImage = styled.div`
  text-align: center;
  ${media.mq[1]} {
    max-width: 770px;
    flex: 1 1 45%;
  }
  ${media.mq[2]} {
    margin: 0 20px;
  }
  .gatsby-image-wrapper {
    max-width: 450px;
    width: 75%;
    margin: 20px auto;
    ${media.mq[1]} {
      max-width: 770px;
      width: 100%;
    }
  }
`

const FeaturesText = styled.div`
  padding-right: 50px;
  .gatsby-image-wrapper {
    max-width: 30px;
    ${media.mq[1]} {
      max-width: 45px;
      max-height: 45px;
      margin-bottom: 10px;
    }
  }
  ${media.mq[1]} {
    flex: 1 1 50%;
  }
  ${media.mq[2]} {
    padding-left: 50px;
  }
`

const Title = styled(text.H3)`
  margin: 15px 0;
`
